import { render } from "./AdminRequestWithdrawal.vue?vue&type=template&id=68534c40"
import script from "./AdminRequestWithdrawal.vue?vue&type=script&lang=js"
export * from "./AdminRequestWithdrawal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__